import { inject, Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { HistoryApiService } from "@shared/services";
import { DaysData } from "@shared/models";

@Injectable({
  providedIn: "root",
})
export class AccordionsService {
  historyApiService = inject(HistoryApiService);

  getDaysData(): Observable<DaysData> {
    return this.historyApiService.getDaysData();
  }
}
